module.exports = __webpack_public_path__ + "static/media/checkmark-completed.de8f9866.svg";